module.exports = __webpack_public_path__ + "static/media/bulbguardcam-4.60b1aa6d.jpg";